import DataTable from "../../../Components/DataTable/DataTable";
import { EditFilled, SolutionOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import * as actions from "../../../store/actions/action";
import api from "../../../api/api";
import { connect } from "react-redux";
import { Button, Form, Modal, Select, Tag, message } from "antd";
import CheckPermission from "../../../Util/CheckPermission";
import { Link, useNavigate } from "react-router-dom";
import FlagMapper, { FlagTypes } from "../../../Util/FlagMapper";
import { editError } from "../../../Util/Messages";
import { defaultTermsValue } from "../../../Util/defaultValues";
import { toJalaali } from "jalaali-js";

const UserTypes = ({
  rowSelection,
  LoadingSetter,
  ClearLoading,
  loading,
  ClearError,
  ErrorSetter,
  permissions,
}) => {
  const [editableKeys, setEditableRowKeys] = useState();
  const [selectData, setSelectData] = useState({});
  const [data, setData] = useState();
  const [pagination, setPagination] = useState();
  const [advancedSearchModal, setAdvancedSearchModal] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [tags, setTags] = useState([]);
  const [types, setTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const columns = [
    // product
    {
      title: "محصول",
      dataIndex: "product",
      filterMultiple: false,
      width: "10%",
      filters: [
        { value: "roadmap-3", text: "لایف کوج" },
        { value: "roadmap-psychology", text: "روان‌شناسی" },
      ],

      onFilter: (value, record) => record.product === value,

      render: (product) => {
        switch (product) {
          case "roadmap-3":
            return "لایف کوچ";
          case "roadmap-psychology":
            return "روان‌شناسی";
          default:
            return product;
        }
      },
    },
    // name
    {
      title: "عنوان",
      dataIndex: "title",
      searchable: true,
      width: "15%",
    },
    // // age
    // {
    //   title: "سن",
    //   dataIndex: "age",
    //   searchable: true,
    //   width: "5%",
    // },
    // // gender
    // {
    //   title: "جنسیت",
    //   dataIndex: "gender",
    //   width: "5%",
    //   filters: ["man", "woman", "both"].map((val) => {
    //     return {
    //       value: val,
    //       text: GenderMapper(val),
    //     };
    //   }),
    //   onFilter: (value, record) => {
    //     return record.gender === value;
    //   },
    //   render: (gender) => {
    //     const tagStyle = {
    //       width: "100%",
    //       textAlign: "center",
    //     };
    //     switch (gender) {
    //       case "man":
    //         return (
    //           <Tag style={tagStyle} color="blue">
    //             مرد
    //           </Tag>
    //         );
    //       case "woman":
    //         return (
    //           <Tag style={tagStyle} color="pink">
    //             زن
    //           </Tag>
    //         );
    //       case "both":
    //         return <Tag style={tagStyle}>هردو</Tag>;
    //       default:
    //         return gender;
    //     }
    //   },
    //   renderFormItem: (_, { isEditable, record }) => {
    //     if (isEditable) {
    //       return (
    //         <Select defaultValue={record.gender ? false : record.gender}>
    //           {["man", "woman", "both"].map((el) => {
    //             return (
    //               <Select.Option value={el} key={el}>
    //                 {GenderMapper(el)}
    //               </Select.Option>
    //             );
    //           })}
    //         </Select>
    //       );
    //     }
    //   },
    // },

    // fields
    {
      title: "حوزه‌های کلیدی",
      dataIndex: "area",
      width: "15%",
      filterSearch: true,
      filters: FlagTypes.map((val) => {
        return {
          value: val,
          text: FlagMapper(val).title,
        };
      }),
      onFilter: (value, record) => {
        if (Array.isArray(record.area)) {
          return record.area.includes(value);
        } else {
          return false;
        }
      },
      render: (arrayOfArea) => {
        if (Array.isArray(arrayOfArea)) {
          return arrayOfArea.map((area) => {
            const flagData = FlagMapper(area);
            return flagData ? (
              <Tag
                color={flagData.circleColor}
                style={{
                  color: flagData.titleColor,
                  borderColor: flagData.titleColor,
                }}
              >
                {flagData.title}
              </Tag>
            ) : (
              area
            );
          });
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select
              mode="multiple"
              defaultValue={record.area ? false : record.area}
            >
              {FlagTypes.map((type) => {
                return (
                  <Select.Option value={type}>
                    {FlagMapper(type).title}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
    },

    // tags
    {
      title: "صفت‌ها",
      dataIndex: "tag",
      width: "15%",
      filterSearch: true,
      filters: tags?.map((pr) => ({ text: pr, value: pr })) ?? [],
      onFilter: (val, record) => record?.tag?.includes(val),
      render: (arrayOfTags) => {
        if (Array.isArray(arrayOfTags)) {
          return arrayOfTags.map((tag) => {
            return (
              <div
                style={{
                  overflow: "hidden",
                  maxWidth: "7rem",
                  wordBreak: "break-word",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  height: "auto",
                  display: "inline-block",
                  backgroundColor: "whitesmoke",
                  borderRadius: "6px",
                  margin: "0.125rem",
                  padding: "0.125rem 0.5rem",
                }}
              >
                {tag}
              </div>
            );
          });
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select mode="tags" defaultValue={record.tag ? false : record.tag}>
              {selectData?.tag?.map((tag) => (
                <Select.Option key={tag} value={tag}>
                  {tag}
                </Select.Option>
              ))}
            </Select>
          );
        }
      },
    },
    // periods
    {
      title: "بازه‌های زمانی",
      dataIndex: "period",
      width: "10%",
      filterSearch: true,
      filters: periods?.map((pr) => ({ text: pr, value: pr })) ?? [],
      onFilter: (val, record) => record?.period?.includes(val),
      render: (arrayOfPeriods) => {
        if (Array.isArray(arrayOfPeriods)) {
          return arrayOfPeriods.map((period) => {
            return <Tag>{period}</Tag>;
          });
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select
              mode="tags"
              defaultValue={record.period ? false : record.period}
            >
              {selectData?.period?.map((per) => (
                <Select.Option key={per} value={per}>
                  {per}
                </Select.Option>
              ))}
            </Select>
          );
        }
      },
    },
    // desc
    {
      title: "توضیحات",
      searchable: true,
      dataIndex: "description",
      width: "15%",
    },
    // created at
    {
      title: "تاریخ ساخت ",
      width: "8%",
      align: "center",
      dataIndex: "createdAt",
      editable: false,
      // sorter: (a, b) => {
      //   const Adate = new Date(a.createdAt);
      //   const Bdate = new Date(b.createdAt);

      //   return Bdate - Adate;
      // },
      render: (text, record) => {
        const date = new Date(text);
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd} {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
    },
  ];

  const getSelectOptions = () => {
    api
      .get("roadmaptypes/report")
      .then((res) => {
        setSelectData(res.data);
      })
      .catch(() => message.error("خطا در دریافت گزینه های تایپ ها"));
  };

  useEffect(() => {
    getSelectOptions();
  }, []);

  useEffect(() => {
    if (
      permissions !== null &&
      CheckPermission("ways_list", permissions) === false
    ) {
      navigate("/permissionDenied");
    }
  }, [permissions]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = (page = 1, pageSize = 100, typeFilters = {}) => {
    LoadingSetter();
    api
      .post("/roadmaptypes/all", {
        page,
        pageSize,
        ...typeFilters,
        ...form.getFieldsValue(),
      })
      .then((res) => {
        setData(res.data.data);

        setPeriods(Array.from(res.data.periods));
        setTags(Array.from(res.data.tags));
        const typesObject = {};
        res.data.types.forEach((q) => (typesObject[q.title] = q.options));
        setTypes(typesObject);

        setPagination(res.data.pagination);
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
      });
  };

  const onSave = (row, rowData) => {
    let oldData = null;
    [...data].forEach((item, index) => {
      if (item.id === row.id) {
        oldData = item;
      }
    });
    // console.log(rowData)
    LoadingSetter();
    const postData = rowData;
    delete postData["id"];
    delete postData["index"];
    if (oldData === null) {
      api
        .post("/roadmaptypes", {
          ...postData,
          flagsRoadmap: defaultTermsValue,
        })
        .then((res) => {
          ClearLoading();
          loadData();

          // console.log(res.data);
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
    } else {
      api
        .put("/roadmaptypes/" + oldData.id, { ...postData })
        .then((res) => {
          // console.log(res.data);
          ClearLoading();
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
    }
  };

  const onSubmitAdvancedSearch = () => {
    const answers = form.getFieldsValue();
    const finalSearchTypes = Object.keys(answers)
      .filter((e) => e && answers[e])
      .map((e) => ({ question: e, value: answers[e] }));
    setSelectedTypes(finalSearchTypes);
    setAdvancedSearchModal(false);
    loadData();
  };

  const filtersBeautify = (data) => {
    return {
      ...(data?.product?.at(0) ? { product: data?.product?.at(0) } : {}),
      ...(data?.title?.at(0) ? { title: data?.title?.at(0) } : {}),
      ...(data?.description?.at(0)
        ? { description: data?.description?.at(0) }
        : {}),

      area: data?.area?.at(0) ? data?.area : [],
      tag: data?.tag?.at(0) ? data?.tag : [],
      period: data?.period?.at(0) ? data?.period : [],
    };
  };

  return (
    <div>
      <Modal
        title="جستجوی پیشرفته"
        open={advancedSearchModal}
        destroyOnClose
        onCancel={() => setAdvancedSearchModal(false)}
        footer={
          <>
            <Button onClick={onSubmitAdvancedSearch}>جستجو</Button>
          </>
        }
      >
        <Form
          form={form}
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
          style={{ direction: "rtl", marginTop: "2rem" }}
        >
          {Object.keys(types).map((key) => (
            <Form.Item key={key} name={key} label={key}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="انتخاب کنید"
                options={types[key].map((e) => ({
                  label: e,
                  value: e,
                }))}
              />
            </Form.Item>
          ))}
        </Form>
      </Modal>
      <DataTable
        tableKey="roadmap-types"
        rowSelection={rowSelection}
        filtersBeautify={filtersBeautify}
        hideErrorReport
        hideComment
        dynamicPagination
        recordsCount={pagination?.total}
        header={{
          title: "تایپ‌ها",
          avatar: { icon: <SolutionOutlined />, size: "large" },
          extra: (
            <Button onClick={() => setAdvancedSearchModal(true)}>
              جستجوی پیشرفته
            </Button>
          ),
        }}
        editable
        keepPageOnSave
        path="/roadmapTypes"
        columns={columns}
        dataSource={data}
        setDataSource={setData}
        editableKeys={editableKeys}
        onSave={onSave}
        reload={loadData}
        recordDefault={{
          createdAt: new Date().toString(),
        }}
        permissionsPrefix="ways"
        operationExtra={(record) => {
          return (
            <Link to={`/type/${record.id}`}>
              <Button type="primary" icon={<EditFilled />}>
                نقشه راه
              </Button>
            </Link>
          );
        }}
        setEditableRowKeys={setEditableRowKeys}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    waysData: state.ways,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
    loadData: () => dispatch(actions.getDatabase()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserTypes);
